const select = (function() {
    $("select:not(.gt_selector)").each(function() {
        var $select = $(this);
        $select.wrap('<div class="custom-select"></div>');
    });
})();